import { render, staticRenderFns } from "./RegisterBooksList.vue?vue&type=template&id=0ae51e0f&"
import script from "./RegisterBooksList.vue?vue&type=script&lang=js&"
export * from "./RegisterBooksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports